import { createApp, configureCompat } from 'vue';
import generalMixins from './helpers/mixins';
import I18NextVue from 'i18next-vue';
import SearchPage from './components/search/SearchPage.vue';
import VueGoogleMaps from 'vue-google-maps-community-fork';

configureCompat({
  WATCH_ARRAY: false,
  RENDER_FUNCTION: false,
  COMPONENT_ASYNC: false,
  COMPONENT_V_MODEL: false
})

window.vm = createApp(SearchPage)
  .mixin(generalMixins)
  .use(I18NextVue, { i18next })
  .use(VueGoogleMaps, {
    load: {
      // Google API key
      key: window.mapsApiKey,
      // Use new renderer
      useBetaRenderer: true,
    },
    autobindAllEvents: true,
  })
  .mount('#search-page')
